import { calculateMonthProratedAmount } from "@wingspanhq/utils/dist/date/banking";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export type WingspanPlanTypes = Exclude<IPlanType, "MeridioHealth">;

const OAI_MONTHLY_PREMIUM = 3;
const PGLI_MONTHLY_PREMIUM = 80;
const PGLI_INITIATION_FEE = 50;

// reference here: https://github.com/wingspanHQ/benefits/blob/staging/src/lib/constants/planEnrollment.ts
export const PLAN_DETAILS: Record<
  WingspanPlanTypes,
  {
    name: string;
    shortName: string;
    monthlyPremium: number;
    monthlyPremiumFormatted: string;
    initiationFee?: number;
    initiationFeeFormatted?: string;
    claimsEmail?: string;
    claimsPhone: string;
    manageUrl?: string;
    claimsUrl?: string;
    eligibleProfessionLabel?: string;
    proratedPremium?: (date: Date) => number;
  }
> = {
  WingspanOccupationalAccidentInsurance: {
    claimsPhone: "1-877-248-3455",
    claimsUrl:
      "https://web.intactspecialty.com/efnol?uniqueId=b5bd77d6-d0e1-4e2d-bf0b-bf845fbd9aae",
    manageUrl: `${window.location.origin}/member/my-resources/independent-contractor-insurance`,
    monthlyPremium: OAI_MONTHLY_PREMIUM,
    monthlyPremiumFormatted: `${OAI_MONTHLY_PREMIUM}%`,
    name: "Wingspan Occupational Accident Insurance (OAI)",
    shortName: "Occupational Accident Insurance"
  },
  WingspanProfessionalLiabilityAndGeneralLiabilityInsurance: {
    claimsEmail: "newclaims@markelcorp.com ",
    claimsPhone: "800-362-7535 (800-3MARKEL)",
    eligibleProfessionLabel: "Independent Claims Adjusters",
    initiationFee: PGLI_INITIATION_FEE,
    initiationFeeFormatted: `$${PGLI_INITIATION_FEE}`,
    manageUrl: `${window.location.origin}/member/my-resources/independent-contractor-insurance`,
    monthlyPremium: PGLI_MONTHLY_PREMIUM,
    monthlyPremiumFormatted: `$${PGLI_MONTHLY_PREMIUM}`,
    name: "Wingspan Professional & General Liability Insurance (PL/GL)",
    proratedPremium: (date: Date) => {
      return calculateMonthProratedAmount(date, PGLI_MONTHLY_PREMIUM);
    },
    shortName: "Professional & General Liability Insurance"
  }
};

export const PGLI_KEY =
  "WingspanProfessionalLiabilityAndGeneralLiabilityInsurance" as const;

export const OAI_KEY = "WingspanOccupationalAccidentInsurance" as const;

export const PLAN_TYPES: WingspanPlanTypes[] = [PGLI_KEY, OAI_KEY];

export const MERIDIO_KEY = "health-insurance";
